import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M37.433 10a14.3 14.3 0 0 1-4.1 1.15 7.16 7.16 0 0 0 3.134-3.967 14.4 14.4 0 0 1-4.534 1.75c-1.316-1.433-3.166-2.266-5.266-2.266-3.917 0-7.117 3.2-7.117 7.15 0 .566.067 1.116.183 1.633A20.32 20.32 0 0 1 5 7.983a7.1 7.1 0 0 0-.967 3.584c0 2.483 1.25 4.683 3.184 5.933-1.184 0-2.284-.333-3.25-.833v.05A7.155 7.155 0 0 0 9.7 23.733a7 7 0 0 1-3.217.117 7.13 7.13 0 0 0 6.667 4.967c-2.527 2-5.66 3.082-8.883 3.066a15 15 0 0 1-1.7-.1A20.24 20.24 0 0 0 13.533 35c13.134 0 20.35-10.9 20.35-20.35 0-.317 0-.617-.016-.933 1.4-1 2.6-2.267 3.566-3.717"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }